// App .egp-app
import React, { Component } from "react";
import jsonLangData from "../assets/language-de-fr-it.json";
import "./App.scss";
import EgpStepFactory from "./EgpStepFactory";
import EgpHeader from "../components/EgpHeader";
import EgpStepID from "../constants/EgpStepID";
import LanguageService from "../services/LanguageService";
import { authenticationService } from "../services/AuthenticationService";
import GOImage from"../assets/Vector.png"
//
class App extends Component {
  constructor() {
    super();
    this.langService = new LanguageService(jsonLangData);
    const currentLanguageKey = "de";
    const currentStep = authenticationService.currentUserValue
      ? EgpStepID.UPLOAD
      : EgpStepID.LOGIN;
    this.handleChangeLanguage = this.handleChangeLanguage.bind(this);
    this.handleChangeStep = this.handleChangeStep.bind(this);
    this.state = {
      langName: this.langService.getName(currentLanguageKey),
      steps: this.langService.getSteps(currentLanguageKey),
      currentStep,
    };
    console.log("McDonalds Sporthilfe", "v1.1.0", "31.05.2021", "✅");
  }

  handleChangeLanguage(item) {
    const key = item.label.toLowerCase();
    const newSteps = this.langService.getSteps(key);
    /* this.setState((state, props) => ({
      langName: item.label,
      steps: newSteps
    })); */
    this.setState({
      langName: item.label,
      steps: newSteps,
    });
  }

  handleChangeStep(step) {
    //console.info('handleChangeStep step:', step);
  }
  setBodyHeightToImage = () => {
    if (window.innerWidth <= 770 && this.goImageRef) {
      const imageBottom = this.goImageRef.getBoundingClientRect().bottom + window.scrollY; 
      document.body.style.height = `${imageBottom + 50}px`;
    } else {
      document.body.style.height = ""; 
    }
  };
  
  componentDidMount() {
    this.setBodyHeightToImage();
    window.addEventListener("resize", this.setBodyHeightToImage);
  }
  
  componentDidUpdate() {
    this.setBodyHeightToImage();
  }
  
  componentWillUnmount() {
    window.removeEventListener("resize", this.setBodyHeightToImage);
  }
  
  render() {
    const langName = this.state.langName;
    const langList = this.langService.getList();
    const { steps, currentStep } = this.state;
    //console.info('App render currentStep:', currentStep);
    return (
      <div className="egp-app hero-container">
        <div className="background-image" />
        <div className="GradientOverlay" />
        <div className="clip-diagonal" />

        <div className="hero-content">
          <EgpHeader
            langName={langName}
            langList={langList}
            onChangeLanguage={this.handleChangeLanguage}
          ></EgpHeader>
           <div className="flex justify-center pt-12"> 
          <img
            src={GOImage}
            alt="GO!"
            className="go-image"
            ref={(el) => (this.goImageRef = el)}

          />
        </div>
          <EgpStepFactory
            debug={false}
            current={currentStep}
            steps={steps}
            onChangeStep={this.handleChangeStep}
          ></EgpStepFactory>
        </div>
      </div>
    );
  }
}

export default App;

//rel="noopener noreferrer"
